const version = process.env.REACT_APP_BUILD_VERSION || '';
console.log('App Version: ', version);
console.log('Run with env: ', process.env.REACT_APP_ENVIRONMENT);

export const env = {
  AXIOS_URL_DEV: 'http://localhost:4242/',
  AXIOS_URL: `https://wild-service.${process.env.REACT_APP_DOMAIN}/`,
};
